<template>
  <div id="app">
    <router-view :key="$route.path" />
  </div>
</template>

<script>

import 'nprogress/nprogress.css';
import 'toastr/build/toastr.min.css';
import 'daterangepicker/daterangepicker.css';
export default {};
</script>
<style>
/* @import "~@/assets/plugins/daterangepicker/daterangepicker.css"; */

@import "https://fonts.googleapis.com/css?family=Montserrat:400,500|Poppins:400,500,600,700|Roboto:400,500";
@import "https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/7.4.47/css/materialdesignicons.min.css";

@import "~@/assets/css/sleek.css";
@import "~@/assets/css/bootstrap.css";
@import '~@/assets/css/fashi.css';
@import "~@/assets/css/main.css";
@import "~@/assets/css/colors.css";
@import "~@/assets/css/buttons.css";
@import "~@/assets/css/badges.css";
@import "~@/assets/css/search.css";

</style>